// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__YF8v3","modal-with-footer":"styles_modal-with-footer__2A5aL"};